import PermintaanProduksiAsetApi from "./PerimntaanProduksiAsetApi";

export default PermintaanProduksiAsetApi;
